import React from 'react';
import { AccountSelector } from './AccountSelector';
import { Actions } from './Actions';
import { TopBarContainer } from './TopBar.styles';

export const TopBar = () => {
  return (
    <TopBarContainer span={24}>
      <AccountSelector />
      <Actions />
    </TopBarContainer>
  );
};
